module.exports = __webpack_public_path__ + "static/one-percent-swiper_img02-c8a3d7bf79e4e1a8ce7eeb89185e3246.jpg";